import FullPage from 'components/LayoutThumbnail/layouts/FullPage';
import LargeAndSmall from 'components/LayoutThumbnail/layouts/LargeAndSmall';
import HalfAndHalf from 'components/LayoutThumbnail/layouts/HalfAndHalf';
import VerticalLargeAndSmall from 'components/LayoutThumbnail/layouts/VerticalLargeAndSmall';
import HorizontalSmallAndLarge from 'components/LayoutThumbnail/layouts/HorizontalSmallAndLarge';
import HorizontalLargeAndSmall from 'components/LayoutThumbnail/layouts/HorizontalLargeAndSmall';
import Responsibility from 'components/LayoutThumbnail/layouts/Responsibility';
import Contacts from 'components/LayoutThumbnail/layouts/Contacts';
import Contact from 'components/LayoutThumbnail/layouts/Contact';
// layout not usable
// import Accessibility from 'components/LayoutThumbnail/layouts/Accessibility';
import LargeMap from 'components/LayoutThumbnail/layouts/LargeMap';
import SpaceDetails from 'components/LayoutThumbnail/layouts/SpaceDetails';
import SpaceDetails2 from 'components/LayoutThumbnail/layouts/SpaceDetails2';
import SpaceDetails3 from 'components/LayoutThumbnail/layouts/SpaceDetails3';

import {
	backgroundColors,
} from 'lib/settings';


const defaultImageSlot = {
	type: 'image',
	options: {
		layout: 'default',
		'background-color': backgroundColors.transparent,
	},
	id: '',
	data: [],
};

const defaultTextSlot = {
	type: 'text',
	options: {
		layout: 'default',
		'background-color': backgroundColors.transparent,
	},
	id: '',
	data: {
		value: {
			fi: '<p>Tekstialue...</p>',
			en: '<p>Text area...</p>',
		},
	},
};

const defaultPictogramSlot = {
	type: 'pictogram',
	options: {
		layout: 'default',
		'background-color': backgroundColors.transparent,
	},
	id: '',
	data: {
		title: {
			fi: 'Otsikko',
			en: 'Heading',
		},
		pictograms: [],
	},
};

const defaultMapSlot = 	{
	type: 'map',
	options: {
		layout: 'default',
		'background-color': backgroundColors.transparent,
	},
	id: '',
	data: {},
}

const optionDescriptions = {
	'large-and-small--small-on-left': 'Pieni kuva vasemmalla',
};

const layoutConfig = {

	building: {
		className: 'vertical-large-and-small',
		thumbnail: VerticalLargeAndSmall,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ 'buildingImage', 'buildingAddress' ],
		options: [],
	},

	fullPage: {
		className: 'full-page',
		thumbnail: FullPage,
		allowedComponents: [
			[ 'image', 'text' ]
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot ],
		options: [],
	},
	halfAndHalf: {
		className: 'half-and-half',
		thumbnail: HalfAndHalf,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultTextSlot ],
		options: [],
	},
	verticalLargeAndSmall: {
		className: 'vertical-large-and-small',
		thumbnail: VerticalLargeAndSmall,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultTextSlot ],
		options: [],
	},
	horizontalSmallAndLarge: {
		className: 'horizontal-small-and-large',
		thumbnail: HorizontalSmallAndLarge,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultTextSlot, defaultImageSlot ],
		options: [],
	},
	horizontalLargeAndSmall: {
		className: 'horizontal-large-and-small',
		thumbnail: HorizontalLargeAndSmall,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultTextSlot ],
		options: [],
	},
	LargeAndSmall: {
		className: 'large-and-small',
		name: 'Iso ja pieni kuva',
		thumbnail: LargeAndSmall,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultImageSlot ],
		options: [ 'large-and-small--small-on-left' ],
	},
	contact: {
		className: 'contact',
		thumbnail: Contact,
		allowedComponents: [ [ ] ],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [
			{
				type: 'contact',
				options: {
					layout: 'default',
					'background-color': backgroundColors.transparent,
				},
				id: '',
				data: {},
			}
		],
		options: [],
	},
	contacts: {
		className: 'contacts',
		thumbnail: Contacts,
		allowedComponents: [ [ ] ],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [
			{
				type: 'contacts',
				options: {
					layout: 'default',
					'background-color': backgroundColors.transparent,
				},
				id: '',
				data: {},
			}
		],
		options: [],
	},
	// accessibility: {
	// 	className: 'accessibility',
	// 	thumbnail: Accessibility,
	// 	allowedComponents: [ [] ],
	// 	allowedBrochureTypes: ['master', 'default', 'normal'],
	// 	defaultSlot: [
	// 		{
	// 			type: 'accessibility',
	// 			options: {
	// 				layout: 'default',
	// 				'background-color': backgroundColors.transparent,
	// 			},
	// 			id: '',
	// 			data: {},
	// 		}
	// 	],
	// 	options: [],
	// },
	responsibility: {
		className: 'responsibility',
		thumbnail: Responsibility,
		allowedComponents: [ [] ],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [
			{
				type: 'responsibility',
				options: {
					layout: 'default',
					'background-color': backgroundColors.transparent,
				},
				id: '',
				data: {
					sidebar: 'text',
					columns: '3',
					logos: [],
					items: [],
					images: []
				},
			}
		],
		options: [],
	},
	largeMap: {
		className: 'large-map',
		thumbnail: LargeMap,
		allowedComponents: [
			[ 'text' ],
			[ 'text', 'pictogram' ],
			[],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [
			'buildingAddressLargeMap',
			{
				type: 'buildingProperties',
				options: {
					layout: 'default',
					'background-color': backgroundColors.transparent,
				},
				id: '',
				data: {},
			},
			{
				...defaultPictogramSlot,
				...{
					options: {
						layout: 'default',
						'background-color': backgroundColors.lightBlue,
					}
				}
			},
			defaultMapSlot,
		],
		options: [],
	},
	spaceDetails: {
		className: 'space-details',
		thumbnail: SpaceDetails,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultImageSlot, defaultTextSlot ],
		options: [],
	},
	spaceDetails2: {
		className: 'space-details-2',
		thumbnail: SpaceDetails2,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultTextSlot, defaultImageSlot, defaultImageSlot ],
		options: [],
	},
	spaceDetails3: {
		className: 'space-details-3',
		thumbnail: SpaceDetails3,
		allowedComponents: [
			[ 'image', 'text' ],
			[ 'image', 'text' ],
			[ 'image', 'text' ],
		],
		allowedBrochureTypes: ['master', 'default', 'normal'],
		defaultSlot: [ defaultImageSlot, defaultTextSlot, defaultImageSlot ],
		options: [],
	},
};

export default layoutConfig;
export {
	defaultImageSlot,
	defaultTextSlot,
	defaultPictogramSlot,
	optionDescriptions,
}
